import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CoreDirectivesModule } from '@core/directives/directives';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { IIMetadataItemOptionsDto } from 'app/main/pages/settings/documentfields/metadata-item.dto';
import { IField } from 'app/main/pages/settings/documenttype/document-type-settings-modal/document-type-settings.dto';
import { TranslocoRootModule } from 'app/transloco-root.module';

@Component({
  selector: 'app-select-field',
  templateUrl: './select-field.component.html',
  styleUrls: ['./select-field.component.scss'],
  standalone: true,
  imports: [
    CommonModule, 
    CoreDirectivesModule, 
    TranslocoRootModule, 
    NgSelectModule, 
    FormsModule,
  ],
})
export class SelectFieldComponent {
  
  @ViewChild('docField') docField!: NgSelectComponent;
  @Output() valueChange = new EventEmitter<string>();
  
  @Input({required: true}) value: string | number;
  @Input({required: true}) field: IField;



 
  updateDroplistValue($event: IIMetadataItemOptionsDto): void {
    const value = $event.value;
    this.valueChange.emit(value);
  }




  focusField(): void {
    setTimeout(() => {
      this.docField.open();
    }, 0);
  }
}
